import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import { RUTAS } from '@core/constants/rutas.constants';
import {
  esErrorInteraccionMsal,
  recuperarSesionMsal,
  mostrarFallbackRecuperacion,
  RESULTADO_AGOTADO
} from '@core/auth/recuperacion-sesion';

void (async (): Promise<void> => {
  try {
    await bootstrapApplication(AppComponent, appConfig);
  } catch (err) {
    console.error(err);

    if (!esErrorInteraccionMsal(err)) {
      return;
    }

    const resultado = recuperarSesionMsal(() => globalThis.location.replace(RUTAS.INICIO));
    if (resultado === RESULTADO_AGOTADO) {
      mostrarFallbackRecuperacion();
    }
  }
})();
